import { faAt, faEnvelopeOpen, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import ExportExcel from "../../../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../../../Components/Table";
import {
    ExportarExcelRelatorioDeEnvioReguaController,
    ListarRelatorioDeEnvioReguaController,
} from "../../../../../Controllers/Automacao/Regua/RelatorioEnvioRegua/RelatorioEnvioReguaControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../../hooks/usePaginationFilter";
import {
    IRelatorioReguaRequest,
    ListaRelatorio,
} from "../../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import { useState } from "react";
import VisualizarRelatorioModal from "../VisualizarRelatorioModal";
import filterFactory, {
    dateFilter,
    textFilter,
} from "react-bootstrap-table2-filter";
import LeiaMais from "../../../../../Components/Utils/LeiaMais";

interface IRelatorioReguaProps {
    req: IRelatorioReguaRequest;
}

export default function RelatorioRegua(props: IRelatorioReguaProps) {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const [filtroDsNomeRegua, setFiltroDsNomeRegua] = useState("");
    const [filtroNomeEtapa, setFiltroNomeEtapa] = useState("");
    const [filtroTipoAcao, setFiltroTipoAcao] = useState("");
    const [filtroNomeAcao, setFiltroNomeAcao] = useState("");
    const [filtroCliente, setFiltroCliente] = useState("");
    const [filtroEmail, setFiltroEmail] = useState("");
    const [filtroProduto, setFiltroProduto] = useState("");
    const [filtroClassificacaoContrato, setFiltroClassificacaoContrato] =
        useState("");
    const [filtroAgingDiasContrato, setFiltroAgingDiasContrato] = useState("");
    const [filtroDtEnvio, setFiltroDtEnvio] = useState("");
    const [filtroIdChaveErp, setFiltroIdChaveErp] = useState("");

    const { value: lstRelatorioRegua, loading: lstRelatorioReguaLoading } =
        useAsyncEffect(
            () =>
                ListarRelatorioDeEnvioReguaController({
                    ...props.req,
                    PAGINA: PageFilter.page,
                    DT_FINAL: props.req.dtFinal,
                    DT_INICIAL: props.req.dtInicial,
                    DS_ETAPA_REGUA: filtroNomeEtapa,
                    DS_TIPO_ACAO: filtroTipoAcao,
                    DS_NOME_ACAO: filtroNomeAcao,
                    DS_CLIENTE: filtroCliente,
                    DS_EMAIL: filtroEmail,
                    DS_PRODUTO: filtroProduto,
                    DS_CLASSIFICACAO: filtroClassificacaoContrato,
                    NR_AGING: Number(filtroAgingDiasContrato),
                    DT_ENVIO: filtroDtEnvio,
                    ID_CHAVE_ERP: filtroIdChaveErp,
                    DS_NOME_REGUA: filtroDsNomeRegua,
                }),
            [
                props.req,
                PageFilter.page,
                filtroNomeEtapa,
                filtroTipoAcao,
                filtroNomeAcao,
                filtroCliente,
                filtroEmail,
                filtroProduto,
                filtroClassificacaoContrato,
                filtroAgingDiasContrato,
                filtroDtEnvio,
                filtroIdChaveErp,
                filtroDsNomeRegua,
            ]
        );

    const totalPaginas = lstRelatorioRegua?.NR_PAGINA || 1;

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_HISTORICO_ENVIO",
            text: "Acompanhamento de Réguas",
            formatter: (_c, row) => <RowFormatter {...row} />,
        },
    ];

    function RowFormatter(row: ListaRelatorio) {
        return (
            <div className="card p-2 m-2">
                <div className="d-flex flex-column align-items-center p-3">
                    {
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="remover-tooltip">
                                    Visualizar Relatório
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            VisualizarRelatorioModal({
                                                setShow,
                                                row,
                                            }),
                                        size: "lg",
                                        headerComponent:
                                            "Conteúdo do Relatório",
                                        IconHeader: faEnvelopeOpen,
                                        noFooter: true,
                                    });
                                }}
                            >
                                Visualizar Relatório
                            </button>
                        </OverlayTrigger>
                    }
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <h3 className="font-weight-bolder font-size-normal">
                        <span className="text-dark-75">{row.DS_NOME_ACAO}</span>
                    </h3>
                    <div className="d-flex flex-wrap align-items-start">
                        <span className="label label-light-primary label-inline mr-2 my-1">
                            Aging {row.NR_AGING_DIAS_CONTRATo} Dias
                        </span>
                        {row.DS_EMAIL && (
                            <span className="label label-light-primary label-inline mr-2 my-1">
                                <FontAwesomeIcon icon={faAt} className="mr-1" />{" "}
                                {row.DS_EMAIL}
                            </span>
                        )}
                        <span className="d-flex flex-wrap align-items-center justify-content-between">
                            <span className="d-flex flex-wrap flex-column mr-1 align-items-center">
                                <span className="d-block font-weight-bold">
                                    Data de Envio
                                </span>
                                <span className="label label-light-primary label-inline my-1">
                                    {moment(row.DT_ENVIO).format("ll")}
                                </span>
                            </span>
                        </span>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-evenly g-2">
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Régua
                        </span>
                        <span className="text-dark flex-root font-weight-bold text-center">
                            {row.DS_NOME_REGUA}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Etapa
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_NOME_ETAPA}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Tipo de Ação
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_TIPO_ACAO}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Cliente
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_CLIENTE}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Produto
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_PRODUTO.split("-")[0]} -{" "}
                            {row.DS_IDENTIFICADOR}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Contrato
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.DS_CLASSIFICACAO_CONTRATO}
                        </span>
                    </div>
                    <div className="d-flex flex-column align-items-center p-3">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Chave ERP
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {row.ID_CHAVE_ERP}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    const headerFormatter = (
        column: any,
        colIndex: any,
        { sortElement, filterElement }: any
    ) => {
        return (
            <div className="d-flex flex-column">
                <span>{column.text}</span>
                {filterElement}
            </div>
        );
    };

    const tableViewColumns: Array<ColumnDescription<ListaRelatorio>> = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex d-flex flex-row-reverse g-2 p-2">
                    <div>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="remover-tooltip">
                                    Visualizar Relatório
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-primary"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            VisualizarRelatorioModal({
                                                setShow,
                                                row,
                                            }),
                                        size: "lg",
                                        headerComponent:
                                            "Conteúdo do Relatório",
                                        IconHeader: faEnvelopeOpen,
                                        noFooter: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} size="lg" />
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
        },
        {
            dataField: "DS_NOME_REGUA",
            text: "Régua de Cobrança",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroDsNomeRegua(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_NOME_ETAPA",
            text: "Etapa da Régua",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroNomeEtapa(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_TIPO_ACAO",
            text: "Tipo de Ação",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroTipoAcao(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_NOME_ACAO",
            text: "Nome da Ação",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroNomeAcao(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroCliente(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_EMAIL",
            text: "E-mail",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroEmail(filterValue.toString()),
            }),
        },
        {
            dataField: "DS_PRODUTO",
            text: "Produto",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroProduto(filterValue.toString()),
            }),
            formatter: (c) => {
                const split = c.split("-");
                return (
                    <LeiaMais
                        charLimit={30}
                        customLeiaMais={"+"}
                        customLeiaMenos={"-"}
                    >{`${split[0]} - ${split[2]}`}</LeiaMais>
                );
            },
        },
        {
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação do Contrato",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroClassificacaoContrato(filterValue.toString()),
            }),
        },
        {
            dataField: "NR_AGING_DIAS_CONTRATO",
            text: "Aging Dias",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroAgingDiasContrato(filterValue.toString()),
            }),
        },
        {
            dataField: "DT_ENVIO",
            text: "Data de envio",
            headerFormatter,
            formatter: (c) => moment(c).format("DD/MM/YY HH:mm"),
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: dateFilter({
                comparatorStyle: { display: "none" },
                onFilter: (filterValue) => {
                    const selectedDate = filterValue as any;
                    if (selectedDate && selectedDate.date) {
                        const adjustedDate = new Date(
                            selectedDate.date.getTime() +
                                selectedDate.date.getTimezoneOffset() * 60000
                        );
                        const formattedDate =
                            moment(adjustedDate).format("YYYY-MM-DD");
                        setFiltroDtEnvio(formattedDate);
                    } else {
                        setFiltroDtEnvio("");
                    }
                },
            }),
        },
        {
            dataField: "ID_CHAVE_ERP",
            text: "Chave ERP",
            headerFormatter,
            classes: "p-3 ws-nowrap",
            sort: true,
            filter: textFilter({
                placeholder: "Filtro...",
                onFilter: (filterValue) =>
                    setFiltroIdChaveErp(filterValue.toString()),
            }),
        },
    ];
    return (
        <div>
            <Table
                data={lstRelatorioRegua?.lstRelatorio ?? []}
                keyField="ID_CASO_COBRANCA_REGUA_HISTORICO_ENVIO"
                loading={lstRelatorioReguaLoading}
                noDataIndication={
                    <div className="text-muted text-center">
                        Nenhum resultado
                    </div>
                }
                onTableChange={(type, { page, filters }) => {
                    setPage(page);
                    const filtroKeys = Object.keys(filters);

                    if (filtroKeys.includes("DS_NOME_REGUA")) {
                        setFiltroDsNomeRegua(
                            filters["DS_NOME_REGUA"].filterVal || ""
                        );
                    } else {
                        setFiltroDsNomeRegua("");
                    }
                    if (filtroKeys.includes("DS_NOME_ETAPA")) {
                        setFiltroNomeEtapa(
                            filters["DS_NOME_ETAPA"].filterVal || ""
                        );
                    } else {
                        setFiltroNomeEtapa("");
                    }
                    if (filtroKeys.includes("DS_TIPO_ACAO")) {
                        setFiltroTipoAcao(
                            filters["DS_TIPO_ACAO"].filterVal || ""
                        );
                    } else {
                        setFiltroTipoAcao("");
                    }
                    if (filtroKeys.includes("DS_NOME_ACAO")) {
                        setFiltroNomeAcao(
                            filters["DS_NOME_ACAO"].filterVal || ""
                        );
                    } else {
                        setFiltroNomeAcao("");
                    }
                    if (filtroKeys.includes("DS_CLIENTE")) {
                        setFiltroCliente(filters["DS_CLIENTE"].filterVal || "");
                    } else {
                        setFiltroCliente("");
                    }
                    if (filtroKeys.includes("DS_EMAIL")) {
                        setFiltroEmail(filters["DS_EMAIL"].filterVal || "");
                    } else {
                        setFiltroEmail("");
                    }
                    if (filtroKeys.includes("DS_PRODUTO")) {
                        setFiltroProduto(filters["DS_PRODUTO"].filterVal || "");
                    } else {
                        setFiltroProduto("");
                    }
                    if (filtroKeys.includes("DS_CLASSIFICACAO_CONTRATO")) {
                        setFiltroClassificacaoContrato(
                            filters["DS_CLASSIFICACAO_CONTRATO"].filterVal || ""
                        );
                    } else {
                        setFiltroClassificacaoContrato("");
                    }
                    if (filtroKeys.includes("NR_AGING_DIAS_CONTRATO")) {
                        setFiltroAgingDiasContrato(
                            filters["NR_AGING_DIAS_CONTRATO"].filterVal || ""
                        );
                    } else {
                        setFiltroAgingDiasContrato("");
                    }
                    if (filtroKeys.includes("DT_ENVIO")) {
                        const filtroDtEnvio =
                            filters["DT_ENVIO"]?.filterVal?.date;

                        if (filtroDtEnvio) {
                            const adjustedDate = new Date(
                                filtroDtEnvio.getTime() +
                                    filtroDtEnvio.getTimezoneOffset() * 60000
                            );
                            const formattedDate =
                                moment(adjustedDate).format("YYYY-MM-DD");
                            setFiltroDtEnvio(formattedDate);
                        } else {
                            setFiltroDtEnvio("");
                        }
                    } else {
                        setFiltroDtEnvio("");
                    }
                    if (filtroKeys.includes("ID_CHAVE_ERP")) {
                        setFiltroIdChaveErp(
                            filters["ID_CHAVE_ERP"].filterVal || ""
                        );
                    } else {
                        setFiltroIdChaveErp("");
                    }
                }}
                totalPages={totalPaginas}
                remote={{ pagination: true, filter: true }}
                tableView={{
                    columns: tableViewColumns,
                    sizePerPage: 10,
                    cancelYScroll: true,
                }}
                filter={filterFactory()}
                sizePerPage={10}
                bordered={false}
                columns={columns}
                noSearch
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelRelatorioDeEnvioReguaController({
                        ...props.req,
                        PAGINA: PageFilter.page,
                        DT_FINAL: props.req.dtFinal,
                        DT_INICIAL: props.req.dtInicial,
                        DS_ETAPA_REGUA: filtroNomeEtapa,
                        DS_TIPO_ACAO: filtroTipoAcao,
                        DS_NOME_ACAO: filtroNomeAcao,
                        DS_CLIENTE: filtroCliente,
                        DS_EMAIL: filtroEmail,
                        DS_PRODUTO: filtroProduto,
                        DS_CLASSIFICACAO: filtroClassificacaoContrato,
                        NR_AGING: Number(filtroAgingDiasContrato),
                        DT_ENVIO: filtroDtEnvio,
                        ID_CHAVE_ERP: filtroIdChaveErp,
                        DS_NOME_REGUA: filtroDsNomeRegua,
                        exportExcel: true,
                    })
                }
                nomeArquivo={"Relatorio_Envio_Regua"}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
